import * as React from 'react';

import History16 from './History16';

export const history16 = () => <History16 />;

export default {
    title: 'Icon|Line|History16',
    component: History16,
    parameters: {
        notes: "`import History16 from 'box-ui-elements/es/icon/line/History16';`",
    },
};
